import { render, staticRenderFns } from "./courseTestPartner.vue?vue&type=template&id=22c3980e&scoped=true"
import script from "./courseTestPartner.vue?vue&type=script&lang=js"
export * from "./courseTestPartner.vue?vue&type=script&lang=js"
import style0 from "./courseTestPartner.vue?vue&type=style&index=0&id=22c3980e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c3980e",
  null
  
)

export default component.exports